import ToggleVisibility from "./ToggleVisibilityStack";
import Stack from './Stack'
import "../../Paths/Problems.css";

export default function App() {
  return (
    <div className="App">
      <ToggleVisibility>
        <Stack/>
      </ToggleVisibility>
    </div>
  );
}